import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const TRAIT_LABELS = {
  classCounter: {
    retiarius: 'Specializes vs Retiarius',
    dimachaerus: 'Specializes vs Dimachaerus',
    provocator: 'Specializes vs Provocator',
  },
  stat: {
    strength: '+50 Strength',
    defense: '+50 Defense',
    technique: '+50 Technique',
    speed: '+50 Speed',
    stamina: '+50 Stamina',
    precision: '+50 Precision',
  },
  fightingStyle: {
    aggressive: 'Aggressive Fighter',
    balanced: 'Balanced Fighter',
    defensive: 'Defensive Fighter',
  },
};

export function TraitDisplay({ gladiator, compact = false }) {
  const [expanded, setExpanded] = useState(false);
  const traits = gladiator.traits;

  if (!traits || !traits.selected) {
    return null;
  }

  if (compact) {
    // Compact one-line display for roster - only show class counter and fighting style
    const classLabel = traits.class_counter.charAt(0).toUpperCase() + traits.class_counter.slice(1);
    const styleLabel = traits.fighting_style.charAt(0).toUpperCase() + traits.fighting_style.slice(1);
    
    return (
      <div className="text-xs text-zinc-400 mt-1">
        <span className="text-zinc-500">Traits: </span>
        <span>vs {classLabel}, {styleLabel}</span>
      </div>
    );
  }

  // Collapsible display for ludus
  return (
    <div className="mt-3">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-2 text-sm text-amber-400 hover:text-amber-300 transition-colors w-full"
      >
        {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        <span className="font-cinzel">Traits</span>
      </button>
      
      {expanded && (
        <div className="mt-2 ml-5 space-y-1 text-sm text-zinc-300 border-l border-zinc-800 pl-3">
          <div>{TRAIT_LABELS.classCounter[traits.class_counter]}</div>
          <div>{TRAIT_LABELS.stat[traits.primary_stat]}</div>
          <div>{TRAIT_LABELS.stat[traits.secondary_stat]}</div>
          <div>{TRAIT_LABELS.fightingStyle[traits.fighting_style]}</div>
        </div>
      )}
    </div>
  );
}
